import FormComponent from "./form";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as appSlice from "@/app/app.slice";
import * as helper from "@/common/helper";
import { useHistory } from "react-router-dom";
import { LINKS } from "@/static-texts/links";
const CONTACTS = "Contacts";
function Form() {
  const history = useHistory();
  const dispatch = useDispatch();

  const [isSendRequestEnabled, setSendRequestEnabled] = useState(false);
  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [businessName, setBusinessName] = useState("");
  const [phone, setPhone] = useState("");
  const [requestText, setRequestText] = useState("");
  const [email, setEmail] = useState("");
  const [isPrivacySelected, setPrivacySelected] = useState(false);
  const [vatNumber, setVatNumber] = useState("");

  var status = useSelector(appSlice.selectStatus);

  useEffect(() => {
    setSendRequestEnabled(
      helper.isValidEmail(email) &&
        name?.length &&
        surname?.length &&
        businessName?.length &&
        phone?.length &&
        requestText?.length &&
        isPrivacySelected
    );
  }, [
    businessName,
    email,
    name,
    phone,
    requestText,
    surname,
    isPrivacySelected,
  ]);

  useEffect(() => {
    if (status === appSlice.Status.ASKED) {
      dispatch(appSlice.setStatus({ status: appSlice.Status.IDLE }));
      history.push(LINKS.REQUEST_CONFIRMED);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  const handleSendRequestClick = () => {
    const request = {
      mail: email,
      newsletter: false,
      name: name,
      surname: surname,
      phone: phone,
      requestText: requestText,
      businessName: businessName,
      vatNumber: vatNumber,
      requestFrom: CONTACTS,
    };
    dispatch(appSlice.sendEmailRequest(request));
  };

  const handleEmailChange = (e) => {
    if (e.target.value) {
      setEmail(e.target.value);
    } else {
      setEmail("");
    }
  };

  const handleNameChange = (e) => {
    if (e.target.value) {
      setName(e.target.value);
    } else {
      setName("");
    }
  };

  const handleSurnameChange = (e) => {
    if (e.target.value) {
      setSurname(e.target.value);
    } else {
      setSurname("");
    }
  };

  const handlePhoneChange = (e) => {
    if (e.target.value) {
      setPhone(e.target.value);
    } else {
      setPhone("");
    }
  };

  const handleBuisinessNameChange = (e) => {
    if (e.target.value) {
      setBusinessName(e.target.value);
    } else {
      setBusinessName("");
    }
  };

  const handleRequestTexChange = (e) => {
    if (e.target.value) {
      setRequestText(e.target.value);
    } else {
      setRequestText("");
    }
  };
  const handleVatNumberChane = (e) => {
    if (e.target.value) {
      setVatNumber(e.target.value);
    } else {
      setVatNumber("");
    }
  };

  const handlePrivacySelect = (isActive) => {
    setPrivacySelected(isActive);
  };
  return (
    <FormComponent
      name={name}
      surname={surname}
      businessName={businessName}
      phone={phone}
      email={email}
      requestText={requestText}
      onEmailChange={handleEmailChange}
      onNameChane={handleNameChange}
      onSurnameChange={handleSurnameChange}
      onPhoneChange={handlePhoneChange}
      onRequestTextChange={handleRequestTexChange}
      onBuisinessNameChange={handleBuisinessNameChange}
      onSendReuqestClick={handleSendRequestClick}
      isSendRequestEnabled={isSendRequestEnabled}
      isPravacySelcted={isPrivacySelected}
      onPrivacySelect={handlePrivacySelect}
      vatNumber={vatNumber}
      onVatNumberChane={handleVatNumberChane}
      status={status}
    />
  );
}

export default Form;
